export const EVENT_ROUTE = "events"
